import { useEffect } from 'react';
import useNonNullContext from '../../../../hooks/useNonNullContext';
import { BookingsTableOptionsContext } from './BookingsTableOptionsContext';

export const useInvoiceOptions = (search: string, isActive: boolean) => {
    const {
        invoiceProps: { options: invoiceOptions, onMenuScrollToBottom, isLoading, onInputChange },
    } = useNonNullContext(BookingsTableOptionsContext);

    useEffect(() => {
        if (!isActive || !onInputChange) {
            return;
        }
        onInputChange(search, { action: 'input-change' });
    }, [search, onInputChange, isActive]);

    return { invoiceOptions, onMenuScrollToBottom, isLoading };
};
